interface SchemaJsonLdProps {
  schema: object | object[];
}

export default function SchemaJsonLd({ schema }: SchemaJsonLdProps) {
  const json = JSON.stringify(schema);
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: json }}
    />
  );
}
